import { ApolloError } from '@apollo/client';
import { useTokenInfo } from '@e2m-customer-portal/hooks';
import { isDefined, UserRole } from '@e2m-customer-portal/shared';
import { useTranslation } from 'react-i18next';

interface ChartErrorComponentProps {
  errors: (ApolloError | undefined)[];
}

export function ChartErrorComponent({ errors }: Readonly<ChartErrorComponentProps>) {
  const [t] = useTranslation();
  const { roles } = useTokenInfo();
  const errorsInfo = errors.filter(isDefined);
  return (
    <div className="m-6 bg-error-50/50 rounded-md">
      <p className="p-2 font-light text-sm">{t('COLOCATION_OVERVIEW_CHARTS_GENERIC_ERROR_MESSAGE')}</p>
      {roles.has(UserRole.VPPOperator) && (
        <p className="p-2 font-light text-xs font-mono bg-error-10">
          {errorsInfo.map((er) => `${er?.cause?.path}: ${er?.cause?.message}`)}
        </p>
      )}
    </div>
  );
}
